import React from 'react'
import FrontPage from '../FrontPage'
import Navbar from './Navbar'


export default function Introduction() {
return (
    <>
      <div className='IntroComplete'>
         <FrontPage/>
         <Navbar/>
      </div>
    </>
   )
}
